module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-three-smc/key-1-2020.svg?v=b982ba20";